export default {
  hero: {
    title: 'Contact Us',
    subtitle: 'Let us create a digital future together'
  },
  
  // Seven Service Regions
  serviceRegions: {
    title: 'Seven Service Regions',
    subtitle: 'Professional service teams across the Asia-Pacific region to provide localized support',
    officeAddress: 'Service Center',
    phone: 'Phone Number',
    email: 'Email Address',
    workingHours: 'Working Hours',
    officeHoursNote: 'Response arrangements can be coordinated based on region and service level.',
    noOfficeInfo: 'Service center information for this region is pending confirmation. Please contact us by email first.',
    regions: {
      china: {
        name: 'Mainland China',
        description: 'China operations cover Shanghai, Beijing, and Shenzhen, supporting cross-regional IT delivery and local execution.',
        offices: [
          {
            title: 'Shanghai Service Center',
            addressLines: [
              'Room 1003-1, Guangming Real Estate Building',
              'No. 199 Xizang North Road',
              'Jing\'an District, Shanghai, China'
            ],
            coordinates: { lat: 31.2411, lng: 121.4754 }
          },
          {
            title: 'Beijing Service Center',
            addressLines: [
              'No. 18, Jingjia Road',
              'Yanqi Town, Huairou District',
              'Beijing, China'
            ],
            coordinates: { lat: 40.4018, lng: 116.6766 }
          },
          {
            title: 'Shenzhen Service Center',
            addressLines: [
              'Unit 55, Room 1407, Building B, Phase 1',
              'Tian\'an Innovation Technology Plaza',
              'No. 4 Tairan Road, Futian District, Shenzhen, China'
            ],
            coordinates: { lat: 22.5412, lng: 114.0539 }
          }
        ],
        workingHours: 'Monday to Friday 9:00-18:00'
      },
      hongkong: {
        name: 'Hong Kong',
        description: 'The Hong Kong service center supports international coordination and localized service delivery for cross-border business needs.',
        offices: [
          {
            title: 'Hong Kong Service Center',
            addressLines: [
              'Room A, 1/F., Arthur Commercial Building,',
              '33 Arthur Road, Yau Ma Tei, Kowloon, Hong Kong'
            ],
            coordinates: { lat: 22.3070, lng: 114.1714 }
          }
        ],
        workingHours: 'Monday to Friday 9:30-18:30'
      },
      taiwan: {
        name: 'Taipei',
        description: 'Taiwan service coverage is available, while service center details are pending client confirmation.',
        offices: [],
        workingHours: 'Monday to Friday 9:00-18:00'
      },
      singapore: {
        name: 'Singapore',
        description: 'Singapore serves as a Southeast Asia regional hub for delivery coordination and business communication.',
        offices: [
          {
            title: 'Singapore Service Center',
            addressLines: [
              '10 ANSON ROAD',
              '#27-18',
              'INTERNATIONAL PLAZA',
              'SINGAPORE (079903)'
            ],
            coordinates: { lat: 1.2752, lng: 103.8453 }
          }
        ],
        workingHours: 'Monday to Friday 9:00-18:00'
      },
      japan: {
        name: 'Japan',
        description: 'The Japan service center supports local customers and multilingual delivery for cross-border programs.',
        offices: [
          {
            title: 'Japan Service Center',
            addressLines: [
              '208, 2-9-17 HIGASHITABATA, KITA-KU,',
              'TOKYO 114-0013, JAPAN'
            ],
            coordinates: { lat: 35.7412, lng: 139.7600 }
          }
        ],
        workingHours: 'Monday to Friday 9:00-18:00'
      },
      korea: {
        name: 'Seoul',
        description: 'South Korea service coverage is available, while service center details are pending client confirmation.',
        offices: [],
        workingHours: 'Monday to Friday 9:00-18:00'
      }
    }
  },
  
  // Instant Communication
  instantCommunication: {
    title: 'Instant Communication',
    subtitle: 'Multi-channel quick contact, professional team always at your service',
    liveChat: {
      title: 'Live Chat',
      description: 'Instant response during business hours',
      button: 'Start Chat',
      hours: 'Mon-Fri 9:00-18:00'
    },
    wechat: {
      title: 'WeChat Work',
      description: 'Scan to add WeChat Work',
      qrcode: 'Scan QR code to add',
      qrcodeAlt: 'WeChat Work QR code — scan to connect'
    },
    whatsapp: {
      title: 'WhatsApp',
      description: 'Quick contact for international business',
      button: 'Send Message'
    }
  },
  
  // Form Section
  formSection: {
    consultation: {
      tab: 'Business Inquiry',
      title: 'Business Inquiry',
      description: 'Fill out the inquiry form, and our professional team will contact you within 24 hours to provide customized IT solutions and project recommendations.',
      benefits: {
        analysis: 'Free requirement analysis and solution suggestions',
        demo: 'Professional one-on-one service',
        response: 'Quick response within 24 hours',
        privacy: 'Protect your privacy'
      }
    },
    partnership: {
      tab: 'Business Partnership',
      title: 'Business Partnership',
      description: 'Welcome channel partners, technology alliances, and solution integrators to discuss cooperation with us, jointly expand the business market, and achieve mutual benefits.',
      benefits: {
        channel: 'Channel Partner Program',
        tech: 'Technology Alliance & Integration',
        solution: 'Joint Solution Development',
        support: 'Comprehensive Support & Training'
      }
    },
    inquiryType: {
      label: 'Inquiry Type',
      partnershipLabel: 'Partnership Type',
      placeholder: 'Please select type',
      consultation: {
        solution: 'Solution Consultation',
        product: 'Product Features',
        pricing: 'Pricing & Quote',
        demo: 'Product Demo',
        support: 'Technical Support'
      },
      partnership: {
        channel: 'Channel Partnership',
        technology: 'Technology Alliance',
        integration: 'Solution Integration',
        consulting: 'Consulting Services',
        other: 'Other Partnership'
      }
    },
    region: {
      label: 'Service Region',
      placeholder: 'Please select service region',
      china: 'Mainland China',
      hongkong: 'Hong Kong',
      taiwan: 'Taiwan',
      singapore: 'Singapore',
      japan: 'Japan',
      korea: 'South Korea'
    }
  },
  
  info: {
    title: 'Contact Information',
    address: {
      title: 'Service Center Address',
      content: 'Room 1003-1, Guangming Real Estate Building, No. 199 Xizang North Road, Jing\'an District, Shanghai, China'
    },
    phone: {
      title: 'Phone Number',
      content: '+86 21 8765 4321'
    },
    email: {
      title: 'Email Address'
    },
    hours: {
      title: 'Business Hours',
      content: 'Monday - Friday 9:00-18:00'
    }
  },
  
  social: {
    title: 'Follow Us'
  },
  
  form: {
    title: 'Send Message',
    companyName: 'Company Name',
    companyNamePlaceholder: 'Enter your company name',
    contactName: 'Contact Name',
    contactNamePlaceholder: 'Enter your name',
    position: 'Position',
    positionPlaceholder: 'Enter your position',
    email: 'Email Address',
    emailPlaceholder: 'Enter your email address',
    phone: 'Phone Number',
    phonePlaceholder: 'Enter your phone number',
    industry: 'Industry',
    industryPlaceholder: 'Select your industry',
    industries: {
      technology: 'Technology',
      finance: 'Finance',
      healthcare: 'Healthcare',
      education: 'Education',
      manufacturing: 'Manufacturing',
      retail: 'Retail',
      other: 'Other'
    },
    companySize: 'Company Size',
    companySizePlaceholder: 'Select company size',
    employees: 'employees',
    interestedServices: 'Interested Services',
    serviceOptions: {
      ticketSystem: 'Smart Ticket System',
      aiSolutions: 'AI Solutions',
      dataAnalytics: 'Data Analytics',
      consulting: 'IT Consulting'
    },
    budget: 'Project Budget',
    budgetPlaceholder: 'Select budget range',
    budgetOptions: {
      under50k: 'Under 50K',
      range50k100k: '50K to 100K',
      range100k500k: '100K to 500K',
      range500k1m: '500K to 1M',
      over1m: 'Over 1M'
    },
    message: 'Project Description',
    messagePlaceholder: 'Please describe your project requirements and expectations in detail',
    submit: 'Submit Inquiry',
    submitting: 'Submitting'
  },
  
  success: {
    title: 'Submitted Successfully',
    message: 'We have received your inquiry and will contact you within 24 hours.',
    close: 'OK'
  },
  
  regions: {
    title: 'Service Regions',
    selectRegion: 'Select Region',
    allRegions: 'All Regions'
  }
}
